import type { ContentStatus } from '@/types/content';

export const CONTENT_LIST_LIMIT = 200;
export const CONTENT_LIST_POLL_MS = 30_000;
export const PERSONAS_COMPACT_LIMIT = 500;

export const CONTENT_STATUS_OPTIONS = [
  { value: 'all', label: 'All statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'published', label: 'Published' },
];

export const CONTENT_STATUS_TONE: Record<
  ContentStatus,
  'success' | 'warning' | 'failure' | 'neutral' | 'running'
> = {
  draft: 'neutral',
  approved: 'success',
  rejected: 'failure',
  published: 'running',
  failed: 'failure',
};
